import { gql } from '@apollo/client';

export const getUsersQuery = gql`
  query GetUsers($limit: Int, $skip: Int, $filter: FilterFindManysherlockUserInput) {
    sherlockUserCount(filter: $filter)
    userMany(limit: $limit, skip: $skip, filter: $filter) {
      _id
      email
      status
      roles
      rolesList {
        _id
        name
        teamId
        team {
          _id
          name
          color
        }
      }
      role {
        _id
        name
        teamId
        team {
          _id
          name
          color
        }
      }
      createdAt
      lastLoginAt
    }
  }
`;

export const getTeamsQuery = gql`
  query GetTeams {
    teamMany {
      _id
      name
      color
      createdAt
    }
  }
`;

export const getRolesQuery = gql`
  query GetRoles {
    roleMany {
      _id
      name
      teamId
      team {
        _id
        name
        color
      }
      createdAt
    }
  }
`;

export const getActionsQuery = gql`
  query GetActions {
    actionMany {
      _id
      name
      module
      roles
    }
  }
`;

export const getNotSetActionsQuery = gql`
  query GetNotSetActions {
    actionsNotSet
  }
`;

export const getTeamAndRolesQuery = gql`
  query GetTeamsAndRoles {
    teamMany {
      name
    }
    roleMany {
      name
    }
  }
`;

export const getModulesQuery = gql`
  query GetModules {
    moduleMany {
      _id
      name
      roles
      routes {
        path
        roles
      }
    }
  }
`;
